import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    { path: '', loadChildren: './tabs/tabs.module#TabsPageModule' },
    { path: 'login', loadChildren: './login/login.module#LoginPageModule' },
    { path: 'webpage', loadChildren: './webpage/webpage.module#WebpagePageModule' },  { path: 'cost-detail', loadChildren: './sfa/cost-detail/cost-detail.module#CostDetailPageModule' },
  { path: 'cost-check-detail', loadChildren: './sfa/cost-check-detail/cost-check-detail.module#CostCheckDetailPageModule' },
  { path: 'person-apply-audit', loadChildren: './sfa/person-apply-audit/person-apply-audit.module#PersonApplyAuditPageModule' },

    // { path: 'rowof-check', loadChildren: './icebox/visitplatform/rowof-check/rowof-check.module#RowofCheckPageModule' },
    // { path: 'posm-check', loadChildren: './icebox/visitplatform/posm-check/posm-check.module#PosmCheckPageModule' },
    // { path: 'stock-check', loadChildren: './icebox/visitplatform/stock-check/stock-check.module#StockCheckPageModule' },
    // { path: 'display-check', loadChildren: './icebox/visitplatform/display-check/display-check.module#DisplayCheckPageModule' },


    // { path: 'plan-ready', loadChildren: './icebox/visitplatform/plan-ready/plan-ready.module#PlanReadyPageModule' },
    // { path: 'require-confirm', loadChildren: './icebox/visitplatform/require-confirm/require-confirm.module#RequireConfirmPageModule' },
    // { path: 'sale-into', loadChildren: './icebox/visitplatform/sale-into/sale-into.module#SaleIntoPageModule' },
    // { path: 'execute-end', loadChildren: './icebox/visitplatform/execute-end/execute-end.module#ExecuteEndPageModule' },
    // { path: 'store-inspection', loadChildren: './plugin/store-inspection/store-inspection.module#StoreInspectionPageModule' },
    // { path: 'store-inspection/:storeId', loadChildren: './plugin/store-inspection/store-inspection.module#StoreInspectionPageModule' },
];
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
